import { Link, To } from 'react-router-dom';
import { Theme } from '@mui/material/styles';
import { Typography } from '@mui/material';
import React, { FC, PropsWithChildren, ReactElement } from 'react';

interface Props {
  to: To;
}

export const FooterLink: FC<PropsWithChildren<Props>> = (props: PropsWithChildren<Props>): ReactElement => {
  const { to, children } = props;

  return (
    <Link to={to}>
      <Typography
        variant={'body2'}
        sx={(theme: Theme) => ({
          color: theme.colors.primary,
          fontWeight: 400,
          '&:hover': {
            cursor: 'pointer',
          },
        })}>
        {children}
      </Typography>
    </Link>
  );
};
